/**
 * A list of middleware to decouple them from applyMiddleware method
 */

import auth from './auth';
import emailVerification from './emailVerification';
import payoutSettings from './payoutSettings';
import registration from './registration';

export default [auth, emailVerification, payoutSettings, registration];
